import ApiClient from '@/services/apiClient/ApiClient'

const client = new ApiClient()

export interface ForgotPasswordResponse {
  message: string
}

export interface ForgotPasswordError extends Error {
  message: string
}

/**
 * Request password reset email
 */
export const requestPasswordReset = async (
  email: string
): Promise<ForgotPasswordResponse> => {
  const response = await client.post('/auth/forgot-password', {
    email,
  })

  if (response?.errors?.length > 0) {
    const error = new Error(
      response.errors[0]?.message || 'Failed to send password reset email'
    ) as ForgotPasswordError
    throw error
  }

  return response.data || response
}
